<script lang="ts">

    export let color: string = '#000000';
    export let disabled: boolean = false;
    export let onChange: (color: string) => void;

    let colorElement: HTMLInputElement;

    function updateColor(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!disabled) {
            color = input.value;
            onChange(color);
        }
    }

    function openColorDialog() {
        if (!disabled) {
            colorElement.click();
        }
    }

</script>


<div class="color-picker" class:disabled >
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="color-preview" style="background-color: {color}" on:click={openColorDialog}></div>
    <input type="color" class="color-element-hidden" bind:value={color} on:input={updateColor} bind:this={colorElement} />
</div>

<style>
    .color-picker.disabled {
        cursor: not-allowed;
    }
    .color-preview {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        cursor: pointer;
        border: 1px solid #000;
    }
    .color-picker.disabled .color-preview {
        cursor: not-allowed;
    }
    .color-element-hidden {
        display: none;
    }

</style>